// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-to-action[data-v-61836096]{padding:.5rem;padding:var(--space-8);color:#666;color:var(--grey);font-size:.875rem;font-size:var(--font-size-14);font-weight:400;letter-spacing:0;line-height:18px;min-height:18px;text-align:center}@media (min-width:768px){[data-v-61836096]:root{--media-gap:var(--space-8)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
